'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sellerDetail = require('./remote/sellerDetail');

var SellerDetail = {
    fetchSellerDetailsByIds: _sellerDetail.SellerDetailRemote.fetchSellerDetailsByIds
};

exports.default = SellerDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/sellerDetail.js
// module id = HW2X
// module chunks = 60